import * as tslib_1 from "tslib";
import { AuthService } from '@examsoft/es-login';
var TrackingService = /** @class */ (function () {
    function TrackingService(authService) {
        this.authService = authService;
        this.data = {};
    }
    TrackingService.prototype.ready = function (esId, username, label, obj) {
        this.data = { esId: esId, username: username };
        this.addPageAction(label, obj);
    };
    TrackingService.prototype.getData = function (data) {
        return tslib_1.__assign({}, this.data, data);
    };
    TrackingService.prototype.addPageAction = function (name, obj) {
        newrelic.addPageAction(name, this.getData(obj));
    };
    return TrackingService;
}());
export { TrackingService };
